import { useEffect } from 'react';

export default function useScrollRestoration(key, ready = true) {
  useEffect(() => {
    if (!ready) return;
    const saved = sessionStorage.getItem(`scroll_${key}`);
    if (saved !== null) {
      window.scrollTo(0, parseInt(saved, 10));
    }
    return () => {
      sessionStorage.setItem(`scroll_${key}`, window.scrollY);
    };
  }, [key, ready]);
}
